module.exports = __webpack_public_path__ + "static/media/7.64d7b67b.jpeg";